import { api, getBlob } from "../../services/NetworkBase";

// Products (ENB-568)

export async function GetProducts() {
  try {
    let response = await api.get(`vlp/inventory/products`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetProductById(id) {
  try {
    let response = await api.get(`vlp/inventory/products/${id}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveProduct(product) {
  try {
    let response = await api.post("vlp/inventory/products", { json: product });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateProduct(product) {
  try {
    let response = await api.put("vlp/inventory/products", { json: product });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteProduct(id) {
  try {
    let response = await api.delete(`vlp/inventory/products/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

// Supply orders (ENB-566)

export async function GetSupplyOrders(
  status = "",
  searchText = "",
  priority = "",
  vendorRecordId = "",
  fromDate = "",
  toDate = ""
) {
  try {
    // vendorRecordId and the dates bind to nullable types on the API, so leave them off when blank.
    const vendorParam = vendorRecordId
      ? `&vendorRecordId=${encodeURIComponent(vendorRecordId)}`
      : "";
    const fromParam = fromDate
      ? `&fromDate=${encodeURIComponent(fromDate)}`
      : "";
    const toParam = toDate ? `&toDate=${encodeURIComponent(toDate)}` : "";
    let response = await api
      .get(
        `vlp/inventory/supply-orders?status=${encodeURIComponent(
          status
        )}&priority=${encodeURIComponent(
          priority
        )}&searchText=${encodeURIComponent(
          searchText
        )}${vendorParam}${fromParam}${toParam}`
      )
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetSupplyOrderByPoNumber(poNumber) {
  try {
    let response = await api
      .get(`vlp/inventory/supply-orders/${poNumber}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveSupplyOrder(supplyOrder) {
  try {
    // Responds with the generated PO number.
    let response = await api
      .post("vlp/inventory/supply-orders", { json: supplyOrder })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateSupplyOrder(supplyOrder) {
  try {
    let response = await api.put("vlp/inventory/supply-orders", {
      json: supplyOrder,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateSupplyOrderStatus(poNumber, status) {
  try {
    let response = await api.put(
      `vlp/inventory/supply-orders/${poNumber}/status`,
      { json: status }
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function ReceiveSupplyOrder(receivePayload) {
  try {
    let response = await api.put("vlp/inventory/supply-orders/receive", {
      json: receivePayload,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteSupplyOrder(poNumber) {
  try {
    let response = await api.delete(`vlp/inventory/supply-orders/${poNumber}`);
    return response;
  } catch (error) {
    throw error;
  }
}

// Test kits (ENB-573)

export async function GetTestKits() {
  try {
    let response = await api.get(`vlp/inventory/test-kits`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTestKitById(id) {
  try {
    let response = await api.get(`vlp/inventory/test-kits/${id}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveTestKit(testKit) {
  try {
    let response = await api.post("vlp/inventory/test-kits", { json: testKit });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateTestKit(testKit) {
  try {
    let response = await api.put("vlp/inventory/test-kits", { json: testKit });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteTestKit(id) {
  try {
    let response = await api.delete(`vlp/inventory/test-kits/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}

// Supply order attachments (ENB-566)

export async function GetSupplyOrderAttachments(poNumber) {
  try {
    let response = await api
      .get(`vlp/inventory/supply-orders/${encodeURIComponent(poNumber)}/attachments`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UploadSupplyOrderAttachment(poNumber, formData) {
  try {
    let response = await api
      .post(`vlp/inventory/supply-orders/${encodeURIComponent(poNumber)}/attachments`, {
        body: formData,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteSupplyOrderAttachment(poNumber, id) {
  try {
    let response = await api.delete(
      `vlp/inventory/supply-orders/${encodeURIComponent(poNumber)}/attachments/${id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

// Same (fileName, owner) argument order as GetOrderDocument so DocumentViewer can take either.
export async function GetSupplyOrderAttachmentDocument(fileName, poNumber) {
  return getBlob(
    `vlp/inventory/supply-orders/${encodeURIComponent(
      poNumber
    )}/attachments/document?fileName=${encodeURIComponent(fileName)}`
  );
}
